import { useState } from 'react';

import { AppIcons } from '@backrs_ui/common-ui';

import { Category, SearchCategory } from '@backrs_ui/grow-ui/src/pages/Search/search.types';

import { SecondLevelPopover } from './SecondLevelPopover';
import { TopLevelMenuSelect } from './TopLevelMenuSelect';

type FilterDropdownBaseProps = Readonly<{
  // Common props
  selectedItems?: SearchCategory[];
  onSelect: (newItems: SearchCategory[]) => void;

  // Props for regular filter dropdown
  name: string;
  iconName: AppIcons;

  // Menu items props
  menuItemGroups: Category[][];
  hasSelectedItems: boolean;
}>;

export const FilterDropdown = ({
  selectedItems = [],
  onSelect,
  name,
  iconName,
  menuItemGroups,
  hasSelectedItems,
}: FilterDropdownBaseProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedParentKey, setSelectedParentKey] = useState<SearchCategory | null>(null);

  const menuItems = menuItemGroups.flat();

  return (
    <>
      <TopLevelMenuSelect
        menuItemGroups={menuItemGroups}
        selectedItems={selectedItems}
        onSelect={onSelect}
        setAnchorEl={setAnchorEl}
        setSelectedParentKey={setSelectedParentKey}
        iconName={iconName}
        name={name}
        hasSelectedItems={hasSelectedItems}
      />

      {selectedParentKey && (
        <SecondLevelPopover
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
          selectedParentKey={selectedParentKey}
          menuItems={menuItems}
          selectedItems={selectedItems}
          onSelect={onSelect}
          setSelectedParentKey={setSelectedParentKey}
          name={name}
        />
      )}
    </>
  );
};
